import { Component, OnInit } from '@angular/core';
import { HomeService } from '../home/home.service';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../models/user-profile.model';
import { RoleAccess } from '../../models/role-access.model';
import { UserData } from '../../providers/user-data';
import { NavController, ToastController } from '@ionic/angular';
import { UtilService } from '../../service/util.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-national-stock',
  templateUrl: './national-stock.page.html',
  styleUrls: ['./national-stock.page.scss'],
})
export class NationalStockPage  {

  searchQuery: string = '';
  searchResults: any[] = [];
  loading = false;
  token: any;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  userAccess: any[] = [];
  dataNationalStock:any[]=[];
  counters: string[] = [];
  stockData: any[] = [];

  constructor(
    private storage: Storage,
    private homeService: HomeService,
    private userData: UserData,
    private toastCtrl :ToastController,
    private navCtrl : NavController,
    private utilService:UtilService,
    private router: Router,
  ) {}
  ionViewDidEnter() {
      Promise.all([
        this.storage.get('user_token'),
        this.storage.get('user_profile'),
        this.storage.get('user_menu_access')
      ])
      .then(([token, profile,access]) => {
        if(token) {
          this.token = token;
          this.userProfile = new UserProfile(profile);
          this.userAccess = access;
          window.dispatchEvent(new CustomEvent('user:getmenu'));
          this.roleAccess = this.userData.checkAccess(this.router.url, this.userAccess, this.userProfile);
          if(!this.roleAccess || this.roleAccess.view!='1'){
            this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
            //this.navCtrl.navigateForward(['/']);
            
            this.getDataNationalStock();
          }
          else{
            this.getDataNationalStock();
          }
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
          this.navCtrl.navigateForward(['/login']);
        }
      });
    }
  getDataNationalStock() {
    this.dataNationalStock = [];
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        'year':'2024',
        'month':'10'
      };
      this.homeService.nationalStock(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.dataNationalStock=  response.results.stock_data;
        this.counters = response.results.counters;
        this.stockData = response.results.stock_data_group;
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  
  onSearchChange() {
    if (this.searchQuery.length < 2) {
      this.searchResults = [];
      return;
    }

    this.loading = true;

    // Simulasi ambil data, bisa diganti panggilan ke API
    setTimeout(() => {
      // Simulasi hasil pencarian
      console.log(this.dataNationalStock);
      this.searchResults = this.dataNationalStock.filter(item =>
       ( item.product_name.toLowerCase().includes(this.searchQuery.toLowerCase()) || 
        item.pcode.toLowerCase().includes(this.searchQuery.toLowerCase())) &&
        item.stock >0
      );

      this.loading = false;
    }, 500);
  }
}
